import { Component, Input, OnInit } from '@angular/core';
import {AuthServiceCustom} from 'src/shared/service/auth.service';
import { Contacts } from '../../shared/model/interfaces';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.css'],
    standalone: false
})
export class ContactsComponent implements OnInit {

  clientCode: string;

  @Input() contacts: Contacts;

  constructor(
    private authService: AuthServiceCustom) {
  }

  ngOnInit(): void {
    this.clientCode = this.authService.clientCode;
  }

}
